export default "__VITE_ASSET__DEU_Op$f__"